/**
 * Scroll Reveal — ScrollTrigger entrance animations for home page.
 * Queries [data-reveal] elements and fades them in from below.
 * Respects prefers-reduced-motion.
 */
export function initScrollReveals() {
    if (!window.gsap || !window.ScrollTrigger) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const elements = document.querySelectorAll('[data-reveal]');

    elements.forEach((el) => {
        if (reducedMotion) {
            el.style.opacity = '1';
            return;
        }

        window.gsap.fromTo(el,
            { opacity: 0, y: 40 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 85%',
                    once: true,
                },
            }
        );
    });
}
